/**
 * Chrome upgrades a pointer-focused control to `:focus-visible` on the next
 * keystroke (spec heuristic), so a button clicked with the mouse silently
 * keeps focus and then sprouts the focus ring when the user starts typing.
 * Fix (user-directed 2026-07-27): after a pointer click completes, drop focus
 * from the clicked control. Keyboard activation (click with `detail === 0`)
 * is untouched, so keyboard users keep their ring — the a11y gate stands.
 */

let keyboard = false

/** True when the most recent input was a keystroke rather than a pointer. */
export function lastInputWasKeyboard(): boolean {
  return keyboard
}

export function installPointerFocusGuard(): void {
  window.addEventListener('keydown', () => (keyboard = true), true)
  window.addEventListener('pointerdown', () => (keyboard = false), true)

  document.addEventListener('click', (e) => {
    if (e.detail === 0) return // keyboard "click" (Enter/Space)
    const el =
      e.target instanceof Element
        ? e.target.closest('button, a, [role="button"]')
        : null
    // Leave open popup triggers focused (aria-expanded) — Radix manages them.
    if (
      el instanceof HTMLElement &&
      el === document.activeElement &&
      el.getAttribute('aria-expanded') !== 'true'
    ) {
      el.blur()
    }
  })
}
